import { useEffect } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogActions, FlexGrid, Typography, Button } from "@albo-ui/core";
import { Divider, Alert, Box, Link, ButtonBase } from "@mui/material";
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import SnackbarContent from '@mui/material/SnackbarContent';
import { useClabeCreate } from "./hooks/useClabeCreate";
import solicitud from '../../../images/solicitud.png'
import { AfbClabeCreateProps } from "./types";

export const AfbClabeCreate = ({ open, onClose, changeAlert, changeLoader }: AfbClabeCreateProps) => {
    const { zPos, form, error, loading: loadingRequest, disabled, dropZoneRef, onConfirm, onSelectFile, handleOver, handleLeave, handleDrop, onFormReset, onDownloadFile } = useClabeCreate(open, onClose, changeAlert);

    const action = (
        <ButtonBase onClick={onFormReset} sx={{fontWeight: 'bold', mr: 1}}>Cambiar</ButtonBase>
    );

    const addFile = () => {
        document.getElementById("file").click();
    };

    useEffect(() => {
        changeLoader(loadingRequest);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingRequest]);


    return (
        <Dialog onClose={() => onClose("clabe")} open={open} style={{ display: zPos !== 45 ? "none" : null, minWidth: "600px" }}>
            <DialogTitle>
                <Typography variant='h2'>Creación de CLABE albo</Typography>
            </DialogTitle>

            <DialogContent>
                { !form && 
                    <>
                    <Alert severity={"info"}>
                        Descarga el formato y completalo con los datos de los Clientes. Recuerda no modificar el formato del archivo.
                    </Alert>
                    <Box mt={2}>
                        <Link underline="none" display={"flex"} sx={{cursor: "pointer"}} width={"fit_content"} onClick={onDownloadFile.bind(this)}>
                            <ArrowCircleDownIcon sx={{verticalAlign: "middle", mr: 1}}/>
                            <Typography variant='smallTitle' color='indigo'>Descargar formato.</Typography>
                        </Link>
                    </Box>
                    </>
                }

				<Divider sx={{mt: 2}} />

                { form && form["file_name"] ?
                    <Box sx={{mb: 1, textAlign: "center"}} display={"flex"}>
                        <Box component="img" alignSelf={"center"} alt="solicitud" src={solicitud} width={300}/>
                        <Box py={3} pl={4} alignContent={"center"} display={'grid'}>
                            <SnackbarContent message={form["file_name"]} action={action} sx={{backgroundColor: "cadetblue", mb: 3, fontWeight: 800}} />
                            <Typography variant="paragraph">Estás a punto de <b>iniciar el proceso de migración de nuevas CLABE</b> para {form.length} empresa(s).</Typography>
                            <Typography variant="paragraph">Al finalizar recibirás un correo de confirmación.</Typography>
                            <Typography variant="paragraph">¿Deseas continuar?</Typography>
                        </Box>
                    </Box> 
                    :
                    <>
                    <Box 
                        ref={dropZoneRef} onDragLeave={handleLeave} onDragOver={handleOver} onDrop={handleDrop} onClick={addFile.bind(this, "")}
                        sx={{p: 2, mb: 1, mt: 3, border: "4px dashed lightgray", justifyItems: "center", cursor: "pointer", display: "grid"}}>
                        <Typography variant='paragraph' bold>¿Ya completaste y guardaste el documento?</Typography>
                        <CloudUploadIcon fontSize="large" color="action" sx={{my: 1}}/>
                        <Typography variant="paragraph">
                            Arrastra y suelta tu archivo o <Link >cárgalo desde tus documentos</Link>
                        </Typography>
                        <input id="file" type="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style={{ display: "none" }} onChange={onSelectFile.bind(this)}/>
                    </Box>
                    <Typography variant="paragraph">Formatos válidos: .csv .xls y .xlsx.</Typography>
                    </>
                }

                {error && <Typography variant="smallTitle" color="sunset">{error}</Typography>}
            </DialogContent>

            <DialogActions>
                <FlexGrid container fullHeight fullWidth justify="space-between" alignItems="flex-end" style={{ marginTop: 10 }} spacing={2}>
                    <FlexGrid item>
                        <Button onClick={() => onClose("clabe")} buttonType="secondary" size="normal">Cancelar</Button>
                    </FlexGrid>
                    <FlexGrid item>
                        <Button onClick={onConfirm.bind(this)} disabled={disabled} size="normal">Aceptar</Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    );
};

export default AfbClabeCreate;
